var React = require('react');

function Secure (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#263b4c;}")),React.createElement("title",{"key":1},"secure"),React.createElement("path",{"className":"cls-1","d":"M0,7.5v9H12v-9Zm5.79,5.83-.7.71L3.46,12.41l.71-.7.92.91L7.83,9.88l.71.71ZM3.5,7h-2V4.5a4.5,4.5,0,0,1,9,0V7h-2V4.5a2.5,2.5,0,0,0-5,0Z","key":2})]);
}

Secure.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 12 16.5"};

module.exports = Secure;

Secure.default = Secure;
